import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    effect,
    forwardRef,
    HostBinding,
    inject,
    input,
    output,
    signal,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormArray,
    FormGroup,
    FormGroupDirective,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { Store } from '@ngxs/store';

import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import {
    CustomerType,
    DCLGarageUseTypeFormGroup,
    DCLParkingCarWashUseTypeFormGroup,
    DCLRentalUseTypeFormGroup,
    DigitalClientCardTypeFormGroup,
    EntitySubjectInfoType
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { CheckboxModule } from 'primeng/checkbox';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { ZFloatLabelCarPlateComponent } from '@shared/components/form-components/z-float-label-car-plate/z-float-label-car-plate.component';
import { ZDatePipe } from '../../../pipes/ZDate.pipe';
import { Button, ButtonModule } from 'primeng/button';
import { Observable, Observer, Subject, Subscription, takeUntil } from 'rxjs';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { CarQueryService } from '@shared/services/carquery.service';
import { DateTime } from 'luxon';
@Component({
    selector: 'z-car-registration-number',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ZFloatLabelComponent,
        InputGroupModule,
        InputGroupAddonModule,
        CheckboxModule,
        FloatLabelModule,
        InputTextModule,
        InputMaskModule,
        ZFloatLabelCarPlateComponent,
        ZDatePipe,
        SelectModule,
        ButtonModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZCarRegistrationNumberComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZCarRegistrationNumberComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './z-car-registration-number.component.html',
    styleUrl: './z-car-registration-number.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZCarRegistrationNumberComponent
    implements ControlValueAccessor, Validator
{
    @HostBinding('class') class?: string = 'flex flex-auto flex-col grow gap-4';
    @ViewChild('floatLabelCarPlate')
    floatLabelCarPlate?: ZFloatLabelCarPlateComponent;

    protected rootFormGroup = inject(FormGroupDirective);
    protected carQueryService = inject(CarQueryService);

    label = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    selectedCustomer = input<CustomerType | undefined>();
    DCLCompletionDateTime = input<Date | null | undefined>();
    formGroup = signal<DigitalClientCardTypeFormGroup | undefined>(undefined);

    subjects = signal<(EntitySubjectInfoType | undefined)[] | undefined>(
        undefined
    );
    registrationNumberSelected = output<string | undefined>();
    takeUntilObserver = new Subject<void>();

    // formGroup = input<
    //     | DigitalClientCardTypeFormGroup
    //     // | DCLGarageUseTypeFormGroup
    //     // | DCLRentalUseTypeFormGroup
    //     // | DCLParkingCarWashUseTypeFormGroup
    //     | undefined
    // >(undefined);

    // infoNotesFormGroups = input<FormArray<InfoNoteTypeFormGroup> | undefined>(
    //   undefined,
    // );

    store = inject(Store);
    cd = inject(ChangeDetectorRef);

    dt = DateTime;

    constructor(private controlContainer: ControlContainer) {
        effect(() => {
            if (this.DCLCompletionDateTime() != undefined) {
                console.debug(
                    'this.DCLCompletionDateTime()',
                    this.DCLCompletionDateTime()
                );

                const DCLCompletionDateTime = new Date(
                    this.DCLCompletionDateTime()?.toString() as string
                );
                // ΠΡΟΣΟΧΗ: Εδώ η ημεροηνία είναι της μορφής Mon Aug 25 2025 10:15:01 GMT+0300 (Θερινή ώρα Ανατολικής Ευρώπης) .... και όχι ISO
                this.formGroup()?.controls?.CompletionDateTime?.setValue(
                    DCLCompletionDateTime,
                    { emitEvent: false }
                );
            }
        });

        effect(() => {
            const customer = this.selectedCustomer();
            if (this.selectedCustomer() == undefined)
                this.subjects.set(undefined);

            // this.subjects.set(
            //     customer?.Subjects?.filter(
            //         (subject) => subject.Subject?.PlateNo != undefined
            //     )?.map((subject) => {
            //         subject = {
            //             ...subject,
            //             Subject: {
            //                 ...subject.Subject,
            //                 PlateNo: this.carQueryService?.toGreekPlate(
            //                     subject.Subject?.PlateNo ?? '',
            //                     []
            //                 )
            //                 //PlateNoPlain: subject.Subject?.PlateNo ?? ''
            //             } as any
            //         };
            //         return subject.Subject;
            //     })
            // );
            // this.formGroup()?.controls?.SubjectId?.setValue(
            //     this.subjects()?.[0]?._id,
            //     { emitEvent: false }
            // );
            // this.formGroup()?.controls?.Garage?.controls?.VehicleRegistrationNumber?.setValue(
            //     this.subjects()?.[0]?.PlateNo
            // );
        });
        //this.useFormGroup()?.value.
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */
    ngOnInit() {
        // const form = this.controlContainer.control as FormGroup;
        // form.valueChanges.subscribe((value) => {
        //     console.debug(
        //         'PPPPPPPPPPPPP 3333 ',
        //         value,
        //         value?.CompletionDateTime
        //     );
        // });

        // this.rootFormGroup.valueChanges?.subscribe((value) => {
        //     console.debug(
        //         'PPPPPPPPPPPPP 22222 ',
        //         value,
        //         value?.CompletionDateTime
        //     );
        //     this.cd.detectChanges();
        // });

        this.formGroup.set(this.rootFormGroup.form as any);
        // this.formGroup()?.controls?.CompletionDateTime?.valueChanges?.subscribe(
        //     (value) => {
        //         console.debug('PPPPPPPPPPPPP 11111 ', value);
        //         this.cd.detectChanges();
        //     }
        // );

        this.formGroup()
            ?.valueChanges?.pipe(takeUntil(this.takeUntilObserver))
            .subscribe((formValue) => {
                console.debug(
                    'dclFormGroup -> Registration Number -> ValueChanges',
                    formValue,
                    formValue.CompletionDateTime
                );

                this.formGroup()?.controls?.SubjectId?.enable({
                    emitEvent: false
                });

                if (this.formGroup()?.controls?.DCLNewId?.value != undefined)
                    this.formGroup()?.controls?.SubjectId?.disable({
                        emitEvent: false
                    });

                this.cd.detectChanges();
            });
    }

    ngOnChanges(simpleChange: SimpleChanges) {
        console.debug(simpleChange);
        if (simpleChange['selectedCustomer']?.currentValue != undefined) {
            const customer = this.selectedCustomer();

            // Εδώ άλλαξε τα subjects για να έχουν παυλες οι τιμές που θα βλέπει ο χρήστης στο DropDown
            this.subjects.set(
                customer?.Subjects?.filter(
                    (subject) => subject.Subject?.PlateNo != undefined
                )?.map((subject) => {
                    subject = {
                        ...subject,
                        Subject: {
                            ...subject.Subject,
                            PlateNo: this.carQueryService?.toGreekPlate(
                                subject.Subject?.PlateNo ?? '',
                                []
                            )
                            //PlateNoPlain: subject.Subject?.PlateNo ?? ''
                        } as any
                    };

                    return subject.Subject;
                })
            );

            this.formGroup()?.controls?.SubjectId?.setValue(
                this.subjects()?.[0]?._id,
                { emitEvent: false }
            );

            this.formGroup()?.controls?.Garage?.controls?.VehicleRegistrationNumber?.setValue(
                this.subjects()?.[0]?.PlateNo?.replaceAll('-', '') // Εδώ όμως δεν θέλουμε να στέιλουμε παυλες στην Α.Α.Δ.Ε
                //$event.customerType?.Subjects?.[0]?.Subject?.PlateNo
            );

            this.formGroup()?.controls?.Garage?.controls?.IsForeign?.setValue(
                this.subjects()?.[0]?.IsForeign
            );
        }
    }

    onRegistrationNumberSelected(registrationNumber: string | undefined) {
        this.formGroup()?.controls?.SubjectId?.setValue(undefined, {
            emitEvent: false
        });
        this.registrationNumberSelected.emit(registrationNumber);
    }

    onPlateNoChange(event: SelectChangeEvent) {
        debugger;
        const subject = this.subjects()?.find(
            (subject) => subject?._id == event.value
        );

        //this.registrationNumberSelected.emit(subject?.PlateNo);
        this.formGroup()?.controls?.Garage?.controls?.VehicleRegistrationNumber?.setValue(
            subject?.PlateNo?.replaceAll('-', ''),
            {
                emitEvent: false
            }
        );

        this.formGroup()?.controls?.Garage?.controls?.IsForeign?.setValue(
            subject?.IsForeign
        );

        // this.cd.detectChanges();
    }

    ngOnDestgroy() {
        this.takeUntilObserver.next();
        this.takeUntilObserver.complete();
    }
}
